import React, { useContext } from 'react'
import { Form } from 'antd';
import SelectTypes from '../../../select/SelectTypes';
import { appContext } from '../../../../AppContext';
import TextEditorReadOnly from '../../../text/TextEditorReadOnly';
import PotionRecepyWikiTable from '../wiki/PotionRecepyWikiTable';

export default function PotionWikiForm({
    form,
    onFinish,
    record
}) {

    const layout = useFormLayout();
    const [appState] = useContext(appContext);

    return (
        <>
            <Form 
                form={form}
                {...layout}
                name="basic"
                layout="horizontal"
                onFinish={onFinish}
                >

                <SelectTypes 
                    name={"item"}
                    label={"Item"}
                    rules={[{required:true, message:"Item is needed"}]}
                    url={`/api/item/${appState.storyId}/GetAllItems`}
                    isDisabled={true}
                />

                <Form.Item
                      label={"Description"}
                      name={"description"}
                >
                        <TextEditorReadOnly content={record.item?.description}/>
                </Form.Item>

                <p>Recepies</p>
                <PotionRecepyWikiTable 
                    potion={record}
                />
            </Form>
        </>
    )

    function useFormLayout()
    {
        return {
            hideRequiredMark: true,
            colon: false,
            layout:"inline"
        }
    }
}

